export default {
  settingsBtn: 'theme-settings-button',
  systemBtn: 'theme-system-button',
  lightBtn: 'theme-light-button',
  darkBtn: 'theme-dark-button',
};
